import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Video = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Video' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M15,9 L23,5 L23,19 L15,15 L15,9 Z M1,5 L15,5 L15,19 L1,19 L1,5 Z' />
  </StyledIcon>
);
